@if (!isDwellComponet()) {
<div>
    @if (result > 0) {
    <svg-icon name="arrow-up"
              svgClass="arrow-up-icon"
              [class.green-arrow]="!inverted()"
              [class.red-arrow]="!!inverted()"
              [stretch]="true">
    </svg-icon>
    up {{ formatPercent(result) }}% relative to the previous
    {{ getDay }}‑days
    }
    @if (result < 0) {
    <svg-icon name="arrow-down"
              svgClass="arrow-down-icon"
              [class.green-arrow]="!!inverted()"
              [class.red-arrow]="!inverted()"
              [stretch]="true">
    </svg-icon>
    down {{ formatPercent(result) }}% relative to the previous
    {{ getDay }}‑days
    }
    @if (result === 0) {
    no change relative to the previous 30‑days
    }
</div>
}

@if (isDwellComponet()) {
<div>
    @if (result > 0) {
    <svg-icon name="arrow-up"
              svgClass="arrow-up-icon"
              [class.green-arrow]="!!inverted()"
              [class.red-arrow]="!inverted()"
              [stretch]="true">
    </svg-icon>
    up {{ formatPercent(result) }}% relative to the previous
    {{ getDay }}‑days
    }
    @if (result < 0) {
    <svg-icon name="arrow-down"
              svgClass="arrow-down-icon"
              [class.green-arrow]="!inverted()"
              [class.red-arrow]="!!inverted()"
              [stretch]="true">
    </svg-icon>
    down {{ formatPercent(result) }}% relative to the previous
    {{ getDay }}‑days
    }
    @if (result === 0) {
    no change relative to the previous 30‑days
    }
</div>
}
